export default ({ typography, fontSize }) => ({
  noDataContainer: {
    fontSize: `${fontSize.xLarge}!important`,
    fontFamily: `${typography.pageTitle}!important`,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

